module.exports = __webpack_public_path__ + "static/media/m6.4b2009fd.jpg";